import React, { useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import useStyles from "./styles"
import Button from "@material-ui/core/Button"
import { closeCropDialogDialog } from "actions/crop-dialog-dialog"
import ReactCrop from "react-image-crop"
import { useState } from "react"
import { Box } from "@material-ui/core"
import DialogsContainerDialog from "../DialogsContainer"

const defaultCrop = {
  unit: "px",
  x: 32,
  y: 32,
  width: 100,
  height: 100,
  aspect: 1
}

const CropDialogDialog = () => {
  const classes = useStyles()
  const [crop, setCrop] = useState(defaultCrop)
  const open = useSelector(state => state.cropDialogDialog.open)
  const imageRef = useRef(null)

  const data = useSelector(state => state.cropDialogDialog.data)

  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(closeCropDialogDialog())
  }

  const handleCrop = () => {
    dispatch(closeCropDialogDialog(crop))
  }

  const handleImageLoaded = image => {
    imageRef.current = image
  }

  return (
    <DialogsContainerDialog
      classes={{
        dialogPaper: classes.dialogPaper,
        dialogActions: classes.dialogActions
      }}
      open={open}
      handleClose={handleClose}
      title={"Crop Image for Upload"}
      content={
        <Box
          className={classes.dialogContent}
          display="flex"
          justifyContent="center"
        >
          <ReactCrop
            src={
              data.image && data.image.secure_url ? data.image.secure_url : ""
            }
            crop={crop}
            onImageLoaded={handleImageLoaded}
            onChange={(newCrop, percentCrop) => {
              setCrop({
                ...newCrop,
                x: Math.ceil(newCrop.x),
                y: Math.ceil(newCrop.y),
                width: Math.ceil(newCrop.width),
                height: Math.ceil(newCrop.height),
                imageWidth: imageRef.current.width,
                imageHeight: imageRef.current.height,
                imageNaturalWidth: imageRef.current.naturalWidth,
                imageNaturalHeight: imageRef.current.naturalHeight
              })
            }}
          />
        </Box>
      }
      buttons={
        <Box display="flex" justifyContent="flex-end">
          {/* <Button
            className={classes.closeButton}
            onClick={() => {
              handleClose()
            }}
            variant="text"
          >
            Cancel
          </Button> */}
          <Box flexGrow={1} />
          <Button color="primary" onClick={handleCrop} variant="contained">
            Crop
          </Button>
        </Box>
      }
    />
  )
}

export default CropDialogDialog



// WEBPACK FOOTER //
// ./src/dialogs/CropDialog/index.jsx